<template>
  <f7-page name="roominspection">
    <div class="ri-page">
      <div class="module-label-tip">{{ moduleLabel }}</div>
      <div class="card">
        <div class="card-box">
          <div class="card-box1">
            <div class="con-text-font">
              车&nbsp;&nbsp;&nbsp;&nbsp;间：{{ modelData.facilityName }}
            </div>
            <div class="con-text-font2"></div>
          </div>
          <div class="card-box1">
            <div class="con-text-font">
              产&nbsp;&nbsp;&nbsp;&nbsp;线：{{ modelData.productLine }}
            </div>
            <div class="con-text-font2"></div>
          </div>
          <div class="card-box1">
            <div class="con-text-font">
              工作台：{{ modelData.workshopName }}
            </div>
            <div class="con-text-font2"></div>
          </div>
          <div class="card-box1">
            <div class="con-text-font">巡检员：{{ userInfo.displayName }}</div>
            <div class="con-text-font2"></div>
          </div>
        </div>
      </div>
      <div>
        <div class="card" style="padding-top: 0px; padding-bottom: 0px">
          <div class="card-content card-content-padding">
            <div class="list media-list">
              <question-card
                  v-for="(item, index) in items"
                  :key="item.key"
                  :index="index + 1"
                  :label="item.displayName.zh"
                  :fieldName="item.key"
                  :checked.sync="item.checked"
                  :memo.sync="item.memo"
                  :class="index == 1 ? 'no-border-bottom' : ' '"
              ></question-card>
            </div>
          </div>
        </div>
        <div class="ri_buttom">
          <f7-button raised large fill @click="onSubmit">提交</f7-button>
        </div>
      </div>
    </div>
  </f7-page>
</template>
<script>
import { f7Button, f7List, f7Page } from "framework7-vue";
import QuestionCard from "@/components/card/QuestionCard";
import { addShopfloorList, fetchShopfloorRoom } from "@/api/computercheck.js";
import { fetchUserInfo } from "@/api/user.js";

export default {
  data() {
    return {
      modelData: {},
      userInfo: {},
      items: [],
      modulesUuid: "",
      data: {},
    };
  },
  components: {
    QuestionCard,
    [f7Page.name]: f7Page,
    [f7List.name]: f7List,
    [f7Button.name]: f7Button,
  },
  computed: {
    moduleLabel() {
      return this.modulesUuid === "server" ? "Server巡检" : "设备巡检";
    }
  },
  async mounted() {
    document.title = "Shopfloor IT Devices Check";
    this.id = this.$f7route.query.id;
    await this.getShopfloorRoom();
    this.getUserInfo();
    this.toastCenter = this.$f7.toast.create({
      text: "提交成功",
      position: "center",
      closeTimeout: 2000,
    });
    this.toast = this.$f7.toast.create({
      text: "异常的备注不能为空",
      position: "top",
      closeTimeout: 1000,
    });
  },
  methods: {
    onSubmit() {
      let obj = { inspectData: {} };
      let isExist = true;
      for (let item of this.items) {
        if (!item.checked) {
          if (!item.memo) {
            this.toast.open();
            return;
          }
          isExist = false;
        }
        obj.inspectData[item.key] = {
          value: item.checked ? 1 : 0,
          memo: item.memo,
          displayName: item.displayName,
        };
      }
      obj.inspectObjectListId = parseInt(this.data.id);
      obj.inspecter = this.userInfo.displayName;
      obj.inspectState = isExist ? 1 : 0;
      this.$f7.dialog.confirm("确定要提交吗？", "提示", () => {
        this.$f7.preloader.show();
        addShopfloorList(obj)
            .then((res) => {
              if (res.status === 10000) {
                this.$f7router.navigate(`/deviecedetails?id=${res.data.id}`, {
                  pushState: false,
                });
                this.toastCenter.open();
              } else {
                this.$f7.dialog.alert(res.msg, "温馨提示", () => {
                  WeixinJSBridge.invoke("closeWindow");
                });
              }
            })
            .catch((error) => {
              alert(error);
            })
            .finally(() => {
              this.$f7.preloader.hide();
            });
      });
    },
    getShopfloorRoom() {
      fetchShopfloorRoom(this.id, { checkDo: true }).then((res) => {

        this.modelData = res.data.inspectObjectModel;
        this.modulesUuid = res.data.modulesUuid;
        this.data = res.data;
        this.items = [];
        let inspectTemp = res.data.inspectFormStruct ? res.data.inspectFormStruct : res.data.defaultInspectFormStruct;
        for (let e of inspectTemp) {
          this.items.push({
            checked: false,
            memo: "",
            ...e,
          });
        }
        if(res.status===10012){
          this.$f7.dialog.alert(res.msg, "温馨提示", () => {
            WeixinJSBridge.invoke("closeWindow");
          });
        }
      });
      // fetchShopfloorRoom(this.id).then((res) => {
      //   if (res.status === 201) {
      //     this.$f7.dialog.alert(res.msg, "温馨提示", () => {
      //       WeixinJSBridge.invoke("closeWindow");
      //     });
      //   }
      //   this.modelData = res.data;
      // });
    },
    getUserInfo() {
      this.$f7.preloader.show();
      fetchUserInfo()
          .then((res) => {
            this.userInfo = res.data;
          })
          .finally(() => {
            this.$f7.preloader.hide();
          });
    },
  },
};
</script>
<style lang="scss">
.ri-page {
  margin-bottom: 10px;

  .module-label-tip {
    margin: 8px;
    text-align: center;
    font-size: 14px;
    line-height: 30px;
    color: #fff;
    background-color: #4682b4;
    border-radius: 6px;
  }

  .ri_buttom {
    margin: 10px;
  }
}

.page {
  background-color: #efeff4 !important;
}

.box_num {
  padding-top: 5px;
}

.card-content-padding {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
}

.card {
  background: #fff !important;
  position: relative !important;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.2) !important;
}

input:not(.item-input-outline) .item-input-wrap::after {
  height: 0px !important;
}

.md .input:not(.input-outline)::after,
.md .item-input:not(.item-input-outline) .item-input-wrap::after {
  height: 0px !important;
}

.md {
  --f7-radio-size: 18px !important;
  --f7-radio-border-width: 1px !important;
}

.row {
  align-items: center !important;
}

.list .item-content {
  padding-left: 0px !important;
}

.button {
  background-color: #4682b4 !important;
}

.no-border-bottom {
  border-bottom-width: 0px;
}
</style>
